export default __webpack_public_path__ + "tumblr-logo-1.png";